import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { TextButton } from '@zillow/constellation-10';

import { ACCORDION_OPEN_STATE, useAccordionState } from '../../../contexts/AccordionStateContext';
import { useGetListingDetails } from '../../../hooks/queries/properties';

const TOP_OFFSET = 256;

type AccordionStateButtonProps = {
  isVisible?: boolean;
  disabled?: boolean;
};

export const AccordionStateButton = ({ isVisible = true, disabled = false }: AccordionStateButtonProps) => {
  const router = useRouter();
  const listingAlias = router.query.listingAlias as string;

  const { data: listingDetails, isLoading: isListingDetailsLoading } = useGetListingDetails(listingAlias);

  const { openState, setOpenState } = useAccordionState();

  const lastActivatedMs = listingDetails?.lastActivatedMs;
  useEffect(() => {
    if (listingDetails) {
      setOpenState(lastActivatedMs ? ACCORDION_OPEN_STATE.COLLAPSE_ALL : ACCORDION_OPEN_STATE.EXPAND_ALL);
    }
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- preserving existing behavior; not re-verified
  }, [lastActivatedMs, setOpenState]);

  const handleClick = () => {
    if (openState === ACCORDION_OPEN_STATE.EXPAND_ALL) {
      setOpenState(ACCORDION_OPEN_STATE.COLLAPSE_ALL);
      window.scrollTo({ top: TOP_OFFSET, behavior: 'smooth' });
    } else {
      setOpenState(ACCORDION_OPEN_STATE.EXPAND_ALL);
    }
  };

  return (
    <TextButton
      onClick={handleClick}
      css={{
        // oxlint-disable-next-line constellation/no-raw-spacing-values -- `minWidth: 74px` falls between `1800` (72px) and `1900` (76px) on the numeric sizes scale
        minWidth: '74px',
        animation: 'fadeIn linear 0.2s',
        display: isVisible ? 'block' : 'none',
      }}
      disabled={disabled || isListingDetailsLoading}
    >
      {openState === ACCORDION_OPEN_STATE.EXPAND_ALL ? 'Collapse all' : 'Expand all'}
    </TextButton>
  );
};
